<button
  [class]="hostClasses()"
  [disabled]="isLocked()"
  [attr.aria-disabled]="isLocked()"
  [pTooltip]="isLocked() ? (tooltipText() | translate) : null"
  tooltipPosition="top"
  (click)="onClick()"
  type="button"
>
  @if (isLocked()) {
    <i class="fa-solid fa-lock tier-btn__icon" aria-hidden="true"></i>
  } @else {
    <i class="fa-solid fa-crown tier-btn__icon" aria-hidden="true"></i>
  }
  <span class="tier-btn__label">
    {{ actionText() }}&nbsp;<span class="tier-btn__suffix">PRO</span>
  </span>
</button>
